export const arrayToString = (arr?: string[]): string => {
  if (!arr) return "";

  return `${arr.map((str) => ` ${str}`)}`;
}